module.exports = __webpack_public_path__ + "static/cross-border-logistics-bafed4a79809ecb988499b0150f4546b.png";